/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import { Pagination, Button, Icon, Select } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab } from '../../components';
import { getRemainTime, openNotice, config } from '../../utils/index.js';
import { getMessageList, setMessageRead, getNoMessageCount } from '../../service/home';
import {Store, Actions} from './store';
import '../../components/style.css';
const Option = Select.Option;
let imgData = {
  'photo': require('../../assets/images/ic-dy-man03.png')
};

class MessageList extends Reflux.Component {
  constructor (props) {
    super(props);
    let loginData=  window.localStorage.getItem('login_user_information');
      this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      opts: ['通知'],
      key: 0,
      badge: 3,
      messageData: [],
      total: 0,
      searchObj: {
       entityType:0,
        s: 10,
        p: 1
      }
    };
    this.pageChange = this.pageChange.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  toMsgDetail (item) {
    /* 消息详情 */
    let self = this;
    setMessageRead([item.id]).then(() => {
      getNoMessageCount().then((result) => {
        if (result && result.code == 200) {
          sessionStorage.setItem('not_message_count', result.data.message);
          self.setState({
            'haveMessage': result.data.message
          });
        }
      });
    });
   if(item.messageType == 1){
       hashHistory.push('/order/' + item.entityId+'/conventionalDetail/null');
    }
    if(item.messageType == 2){
       hashHistory.push('/order/' + item.entityId+'/projectDetail/null');
    }
    if(item.messageType == 3){
       hashHistory.push('/order/' + item.entityId+'/partnersDetail/null');
    }
    if(item.messageType == 4){
       hashHistory.push('/traceOrder/' + item.entityId);
    }
    if(item.messageType == 5){
       hashHistory.push('/invoiceManagement/' + item.entityId);
    }
    if(item.messageType == 6){
       hashHistory.push('/returnGoods/' + item.entityId);
    }
    if (item.messageType == 7 || item.messageType == 8) {
      // 7,账号开通申请 8,增值税开通申请
      hashHistory.push('/message/' + item.entityId + '/' + item.messageType);
    }
    if (item.messageType == 9) {
      // 退货订单
      hashHistory.push('/returnOrder/' + item.entityId);
    } 
  }

  goView (url) {
    hashHistory.push(url);
  }

  initData () {
    let self = this;
    let searchObj = this.state.searchObj;
    getMessageList(searchObj).then(function (result) {
      if (result && result.code == 200) {
        self.setState({
          'messageData': result.data || [],
          'total': result.total || 0
        });
      } else {
        openNotice('error', '数据获取失败', '');
      }
    });
  }

  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'message' || path[1] === 'order' || path[1] === 'returnOrder'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    }else{
      Actions.useStoreChange(false);
      Actions.paramChange({});
    }
  }

  componentWillMount () {
    const data = this.store.state;
    if(data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params
        },
        key: data.params.buyerStatus || 0
      });
    }
  }

  componentDidMount () {
    this.initData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  pageChange (page, s) {
    let self = this;
    self.setState({
      'searchObj': {
        ...this.state.searchObj,
        's': s,
        'p': page
      }
    }, function () {
      self.initData();
    });
  }

  backHandle () {
    window.history.go(-1);
  }

  handleChange(value) {

      let self = this;
      let searchObj = this.state.searchObj;
      searchObj.entityType = value;
      getMessageList(searchObj).then(function (result) {
          if (result && result.code == 200) {
              self.setState({
                  'messageData': result.data || [],
                  'total': result.total || 0
              });
          } else {
              openNotice('error', '数据获取失败', '');
          }
      });



  }

  render () {
    const { opts, key, total, searchObj, messageData, badge } = this.state;
    var self = this;
    const pagination = {
      total: total,
      pageSize: searchObj.s,
      current: searchObj.p,
      pageSizeOptions: ['1', '10', '20', '30', '40'],
      showTotal: total => `共 ${total} 条`,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: self.pageChange.bind(self),
      onChange: self.pageChange.bind(self),
      size: "small"
    };
    var messageLiHtml = messageData.map(function (qst, key) {
      return <li key={key} onClick={self.toMsgDetail.bind(self, qst)}>
        <img className="msg" src={qst.photoUrl ? (config.server + qst.photoUrl) : imgData['photo']} alt=""/>
        <span className="redDot" style={{display: qst.isRead ? 'none' : 'block'}}></span>
        <div className="msg">
          <div>
            <p style={{ color: qst.isRead ? '#777' : '#000' }}
               className="na">{qst.title}<span>{getRemainTime(qst.createdDate)}</span></p>
            <p style={{ color: qst.isRead ? '#777' : '#000' }}><span>{qst.subject}</span></p>
          </div>
        </div>
      </li>
    });
    return <div>
      <DmsTab options={opts} defaultKey={key}>
        <label>消息类型：</label>
        <Select defaultValue="all" style={{ width: 120 }} onChange={this.handleChange}>
          <Option value="0">全部</Option>
          <Option value="1">常规订单</Option>
            <Option value="2">项目订单</Option>
            <Option value="3">大客户订单</Option>
            <Option value="4">追溯订单</Option>
            <Option value="5">开票</Option>
            <Option value="6">退货</Option>
            <Option value="7">授信</Option>
        </Select>
        <Button onClick={this.backHandle.bind(this)}>返回</Button>
        <Icon type="arrow-left" style={{ fontSize: 26, cursor: 'pointer',display: 'none' }}/>
      </DmsTab>
      <div className="dms-table-box">
        <div className="product_top_5">
          <ul>
            {messageLiHtml}
          </ul>
        </div>
        <div className="paginationBox">
          <Pagination {...pagination}/>
        </div>
      </div>
    </div>
  }
};
export default withRouter(MessageList);


// WEBPACK FOOTER //
// ./src/routes/message/list.js